import React from 'react';
import ScrollableTabs from "../../../../../../../../../../components/Common/ScrollableTabs";
import {CategoryViewType, ConfigApi} from "../../../../../../../../../../services/Api/types";
import MenuScrollSpy from "../../../../../../../../../../utils/MenuScrollSpy";
import StoreUtils from "../../../../../../../../../../services/Store/StoreUtils";
import {MultistoreMenuCategory} from "../../../../../../../../utils/types";
import MultistoreMenuCategoriesNavbarItem from "./MultistoreMenuCategoriesNavbarItem";

interface Props {
    categories: MultistoreMenuCategory[];
    config: ConfigApi | undefined;
    menuId: number;
}

const MultistoreMenuCategoriesNavbar = ({categories, config, menuId}: Props) => {
    const viewType = StoreUtils.getMenuCategoryViewType(config);

    return (
        <ScrollableTabs hideScrollbars={false}
                        className={`nav-categories-wrapper ${viewType === CategoryViewType.IMAGE ? "nav-categories-wrapper-with-images" : ""}`}
                        scrollStep={60}>
            <MenuScrollSpy value={menuId.toString()} productsViewType={StoreUtils.getMenuProductsViewType(config)}>
                <ul className={`nav flex-nowrap align-items-start ${viewType === CategoryViewType.BASIC ? "gap-4" : "gap-2"}`}>
                    {
                        categories.map((category, index) => (
                                <MultistoreMenuCategoriesNavbarItem key={`${category.id}-${menuId}`}
                                                                    category={category} index={index}
                                                                    type={viewType} config={config}
                                                                    menuId={menuId}
                                />
                            )
                        )
                    }
                </ul>
            </MenuScrollSpy>
        </ScrollableTabs>
    )
}

export default MultistoreMenuCategoriesNavbar;